import type { WidgetConfig } from '../types';

export function reportWidgetInteraction(config: Pick<WidgetConfig, 'onInteraction'>, event: 'avatar' | 'voice' | 'chat'): void {
  if (!config.onInteraction) return;
  try {
    Promise.resolve(config.onInteraction(event)).catch(() => {
      console.warn('[widget-interaction] Tracking callback failed');
    });
  } catch {
    console.warn('[widget-interaction] Tracking callback failed');
  }
}
